
import React from 'react';
import styled, { css, CSSProp } from 'styled-components';

interface StyledContainerProps {
  padding?: boolean;
  inColor?: boolean;
}

const StyledContainer = styled.div<StyledContainerProps>`
  margin: 0 auto;
  width: 100%;
  max-width: 1080px;
  padding: ${({ padding }: { padding?: boolean }) => (padding ? '79px 185px 79px 185px' : '0')};
  background: ${({ inColor }: { inColor?: boolean }) => (inColor ? 'white' : 'transparent')};
  box-sizing: border-box;
  @media screen and (max-width: 1200px) {
    padding: ${({ padding }: { padding?: boolean }) => (padding ? '20px 20px 20px 20px' : '0')};
    margin: 0 auto;
  }
`;

export const Flex = styled.div<{ responsive?: boolean }>`
  display: flex;
  ${({ responsive }): CSSProp => (responsive
    ? css`
      @media screen and (max-width: 760px) {
        display: block
      }
    `
    : '')}
`;

interface Props {
  children: JSX.Element | JSX.Element[] | string;
  inColor?: boolean;
  padding?: boolean;
}

export const Container = ({
  children, inColor, padding, ...props
}: Props): JSX.Element => (
  <StyledContainer
    inColor={inColor}
    padding={padding}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </StyledContainer>
);
